import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import router from './router'
import store from './store'
import axios from "axios";
import "vuetify/dist/vuetify.css";
import "./css/custom-style.css";
import "./css/tooltip-style.css";
import i18n from './i18n'
import FlagIcon from 'vue-flag-icon'
import VTooltip from 'v-tooltip'
import VueRamda from 'vue-ramda'
import storeGettersMixin from "./mixins/storeGettersMixin";

Vue.mixin(storeGettersMixin)
Vue.use(VueRamda)
Vue.use(FlagIcon);
Vue.use(VTooltip);
Vue.config.productionTip = false
Vue.prototype.$http = axios;
const token = localStorage.getItem('token')
if (token) {
  Vue.prototype.$http.defaults.headers.common['Authorization'] = token
}

new Vue({
  vuetify,
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
